/**
 * An enumeration of keyboard code values
 */
export enum Keys {
    up = "ArrowUp",
    down = "ArrowDown",
    left = "ArrowLeft",
    right = "ArrowRight",
    del = "Delete",
    tab = "Tab",
    enter = "Enter",
    esc = "Escape",
    comma = ",",
    space = " ",
    pageUp = "PageUp",
    pageDown = "PageDown",
    home = "Home",
    end = "End",
    backspace = "Backspace"
}
